import * as React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';

export function orgLogoUrl(org, variant) {
  return `${process.env.REACT_APP_MGO_API_URL}/org/${org}/logo/${variant}`;
}

const OrgLogo = ({ org, alt = 'Logo', className, style, sx, ...rest }) => {
  const theme = useTheme();
  const mode = theme.palette.mode;

  const urls = React.useMemo(() => [
    orgLogoUrl(org, mode),
    orgLogoUrl(org, 'original'),
    `/orgs/${org}.png`,
  ], [org, mode]);

  const [step, setStep] = React.useState(0);

  React.useEffect(() => {
    setStep(0);
  }, [org, mode]);

  const handleError = () => {
    setStep((s) => s + 1);
  };

  if (step < urls.length) {
    return (
      <Box
        component="img"
        src={urls[step]}
        alt={alt}
        onError={handleError}
        className={className}
        style={style}
        sx={sx}
        {...rest}
      />
    );
  }

  return <GridViewRoundedIcon className={className} style={style} sx={sx} />;
};

export default OrgLogo;
